import React, { Component } from "react";
import { connect } from "react-redux";
import Popup from "../index";
import Button from "../../common/forms/button/index";
import Actions from "../../../actions/index";
import {
  PopupsConsumer,
  PopupsContext,
} from "../../../helpers/contexts/popupsContext";
import "./styles/index.scss";

class LinkExpiredPopup extends Component {
  state = {
    isOpen: false,
  };

  componentDidUpdate() {
    const { resend, isOpen } = this.props;
    const { isOpen: open } = this.state;
    const context = this.context;
    if (resend && context.state && context.state.linkExpiredPopupIsOpen) {
      context.closeLinkExpiredPopup();
    }

    if (!open && isOpen) {
      this.setState(
        {
          isOpen: true,
        },
        () => {
          context.openLinkExpiredPopup();
        }
      );
    }
  }

  resentLetter = () => {
    const { sentLetterForActivate, code } = this.props;
    sentLetterForActivate(code);
  };

  render() {
    return (
      <PopupsConsumer>
        {({ state, closeLinkExpiredPopup }) => (
          <Popup
            isOpen={state.linkExpiredPopupIsOpen}
            onClosePopup={closeLinkExpiredPopup}
          >
            <div className="popup-container">
              <div className="link-expired-form-container">
                <i
                  className="close-icon"
                  aria-hidden="true"
                  onClick={closeLinkExpiredPopup}
                />
                <div className="warning-logo-icon" />
                <div className="popup-link-expired-body">
                  <div className="popup-link-expired-title">
                    Email already used
                  </div>
                  <div className="popup-link-expired-description">
                    <p>This email already used in previous</p>
                    <p>registration but account still not activated.</p>
                    <p>We can send one more email to activate</p>
                    <p>your account.</p>
                  </div>
                  <Button
                    type="primary"
                    size="large"
                    children={"Send Again"}
                    onClick={this.resentLetter}
                  />
                </div>
              </div>
            </div>
          </Popup>
        )}
      </PopupsConsumer>
    );
  }
}

const mapStateToProps = (state) => {
  const { resend } = state.auth;

  return {
    resend,
  };
};

const mapDispatchToProps = (dispatch) => ({
  sentLetterForActivate: function (data) {
    dispatch(Actions.sentLetterForActivate(data));
  },
});

LinkExpiredPopup.contextType = PopupsContext;

export default connect(mapStateToProps, mapDispatchToProps)(LinkExpiredPopup);
